module.exports = __webpack_public_path__ + "img/leftpic.074b56f1.png";